import { NgModule, ErrorHandler, LOCALE_ID } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { ToastrModule } from 'ngx-toastr';
import { CurrencyPipe, registerLocaleData } from '@angular/common';
import localeES from '@angular/common/locales/es';
import { AppComponent } from './app.component';
import { WINDOW_PROVIDERS } from './core/services/window.service';
import { GlobalsService } from './core/services/globals.service';
import '@progress/kendo-angular-intl/locales/es/all';
import { CustomErrorHandler } from './core/services/custom-error-handler.service';
import { CustomHttpInterceptor } from './core/services/custom-http-interceptor.service';
import { AuthGuardService } from './core/services/auth-guard.service';
import { LoadingModule } from './shared/loading/loading.module';
import { LoadingService } from './shared/loading/loading.service';
import { AuthService } from './core/services/auth.service';
import { DataSaveService } from './core/services/data-save.service';
import { TimerNotifyService } from './core/services/timer-notify.service';
import { GetInitializationStateService } from './login/services/get-initialization-state.service';
import { GetCurrentCultureService } from './login/services/get-culture.service';
import { GetCurrentFilialService } from './login/services/get-current-filial.service';
import { GetSessionProfileService } from './login/services/get-session-profile.service';
import { SearchVehicleBoxService } from './core/components/search-vehicle-box/search-vehicle-box.service';
import { ConfirmModule } from './shared/confirm/confirm.module';
import { ConfirmService } from './shared/confirm/confirm.service';
import { RouteReuseStrategy } from '@angular/router';
import { CustomRouteReuseStategy } from './core/classes/custom-route-reuse';
import { ImprimirService } from './core/services/imprimir.service';
import { StorageService } from './core/services/storage.service';
import { MarcadorFavoritoService } from './shared/components/marcardor-favorito/marcador-favorito.service';
import { CustomTranslateLoader } from './core/classes/custom-tranlate-loader';
import {CustomerValidationService} from './core/services/customer-validation.service';
import {ModalGenericoModule} from './shared/components/modal-generico/modal-generico.module';
import {
    GestionTercerosRegisterModule
} from './core/components/gestion-terceros-register/gestion-terceros-register.module';
import {
    RecepcionVehiculoStepsService
} from './dms/modulos/taller/componentes/recepcion-vehiculo/recepcion-vehiculo-steps.service';
import {
    GeneralGestionTercerosService
} from './dms/modulos/general/componentes/gestion-terceros/servicios/general-gestion-tercerosService.Service';
import {ShortcutService} from './core/services/shortcut.service';
import {GestionFormModule} from './core/components/gestion-form/gestion-form.module';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { ChartsModule } from '@progress/kendo-angular-charts';
import 'hammerjs';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { ExcelExportModule } from '@progress/kendo-angular-excel-export';
import { GridModule } from '@progress/kendo-angular-grid';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { MenuModule } from '@progress/kendo-angular-menu';
import { SchedulerModule } from '@progress/kendo-angular-scheduler';











import {GetCurrentVersionService} from './login/services/get-current-version.service';


registerLocaleData(localeES);
export function HttpLoaderFactory(http: HttpClient) {
    return new CustomTranslateLoader(http);
}

@NgModule({
    declarations: [
        AppComponent,
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        LoadingModule,
        ConfirmModule,
        AppRoutingModule,
        ToastrModule.forRoot({
            timeOut: 2000,
            // disableTimeOut: true,
            progressAnimation: 'decreasing',
            positionClass: 'toast-top-right',
            preventDuplicates: true,
        }),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                //useClass: CustomTranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
        ModalGenericoModule,
        GestionTercerosRegisterModule,
        GestionFormModule,
        ButtonsModule,
        ChartsModule,
        DateInputsModule,
        DialogsModule,
        DropDownsModule,
        ExcelExportModule,
        GridModule,
        InputsModule,
        LayoutModule,
        MenuModule,
        SchedulerModule
    ],
    providers: [
        CurrencyPipe,
        GlobalsService,
        ShortcutService,
        AuthService,
        WINDOW_PROVIDERS,
        AuthGuardService,
        LoadingService,
        ConfirmService,
        GetInitializationStateService,
        GetSessionProfileService,
        GetCurrentCultureService,
        GetCurrentFilialService,
        GetCurrentVersionService,
        DataSaveService,
        TimerNotifyService,
        SearchVehicleBoxService,
        MarcadorFavoritoService,
        StorageService,
        ImprimirService,
        CustomerValidationService,
        { provide: LOCALE_ID, useValue: 'es-ES' },
        { provide: ErrorHandler, useClass: CustomErrorHandler },
        { provide: HTTP_INTERCEPTORS, useClass: CustomHttpInterceptor, multi: true },
        { provide: RouteReuseStrategy, useClass: CustomRouteReuseStategy },
        RecepcionVehiculoStepsService,
        GeneralGestionTercerosService,
    ],
    bootstrap: [AppComponent],

})
export class AppModule { }
